
<div class="card mb-5">
  <div class="card-header" style="border-bottom: none; padding: 4px 6px;">
    <div class="card-title d-flex flex-column">
      <h6 style="margin: 0; font-size: calc(0.95rem * var(--dvm-font-scale, 1)); text-align: center;">
        {{ data.title }}
      </h6>
    </div>
  </div>

  <div class="card-body" style="padding: 4px;">
    <!-- ✅ Custom Legend -->
    <div class="legend-wrapper" *ngIf="chartData.length > 0">

      <button
        class="scroll-arrow"
        *ngIf="showLeftArrow"
        (click)="scrollLegend('left')">
        ‹
      </button>

      <div
        #legendContainer
        class="custom-legend-container"
        (scroll)="updateArrowVisibility()">

        <div
          class="legend-item"
          *ngFor="let item of chartData"
          (click)="onLegendItemClick(item)"
          [style.cursor]="data?.enableLegendClick ? 'pointer' : 'default'"
          [style.opacity]="currentlySelectedIndices.length === 0 ? 1 : (allSliceNames.indexOf(item.label) !== -1 && currentlySelectedIndices.includes(allSliceNames.indexOf(item.label)) ? 1 : 0.3)">

          <span
            class="legend-color-box"
            [style.background]="item.color">
          </span>

          <span class="legend-label">
            {{ item.label }}
          </span>

        </div>
      </div>

      <button
        class="scroll-arrow"
        *ngIf="showRightArrow"
        (click)="scrollLegend('right')">
        ›
      </button>

    </div>

    <div
      [id]="data.widgetId"
      [style.height]="data?.height || 'var(--dvm-chart-height-lg, 58vh)'"
      style="width: 100%;"
    ></div>
  </div>
</div>